// file import
import { useState } from 'react';
import styles from '../../css/Report.module.css';
import ToggleBtn from './ToggleBtn';
import Business from './Business';
import Sales from './Sales';
import Population from './Population';
import { FcExpand, FcCollapse } from 'react-icons/fc';

export default function ReportSideBar({
  state,
  setState,
  itemData,
  setIsExpanded,
  reportBusiness,
  handleTabSelect
}) {
  const [activeTab, setActiveTab] = useState(0);

  const ComponentProps = {
    itemData
  }

  const tabs = [
    {
      title: '상권분석',
      content: <Business {...ComponentProps} />
    },
    {
      title: '매출분석',
      content: <Sales {...ComponentProps} />
    },
    {
      title: '유동인구',
      content: <Population {...ComponentProps} />
    }
  ]

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })

    if (tabIndex == 2) {
      handleTabSelect(true);
    } else {
      handleTabSelect(false);
    }
  }

  return (
    <div className={`${styles.resultPage} 
                    ${state.toggle ? styles.startShow : styles.stopShow}`}>

      <ToggleBtn state={state}
        setState={setState}
        setIsExpanded={setIsExpanded}
        reportBusiness={reportBusiness}
        menu='false' />

      <div className={`${styles.midToggle} ${state.toggle ? styles.none : styles.blue}`}
        onClick={() => { setState({ ...state, toggle: !state.toggle }) }}>
        {
          state.toggle ?
            <FcExpand className={styles.icon} /> : <FcCollapse className={styles.icon} />
        }
      </div>
      <div className={styles.nav}>

        <ul className={styles.businessNav}>
          {
            tabs.map((tab, idx) => (
              <li key={idx}
                className={activeTab == idx ? 'active' : ''}
                onClick={() => handleTabClick(idx)}>
                {tab.title}
              </li>
            ))
          }
        </ul>

      </div>
      {/* 결과 report */}
      <div className={styles.result}>
        {tabs[activeTab].content}
      </div>
    </div>
  )
}